import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const latestArticles = articles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export default function LatestNews() {
  const [activeIndex, setActiveIndex] = useState(0);
  const featured = latestArticles[activeIndex % latestArticles.length];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + latestArticles.length) % latestArticles.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % latestArticles.length);
  };

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[40%]">
            <Link
              to={`/article/${featured.slug}`}
              className="block rounded-2xl overflow-hidden group cursor-pointer"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  title={featured.title}
                />
              </div>
            </Link>
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center">
            <span className="text-xs text-foreground-400 font-medium mb-3 whitespace-nowrap">
              （ 今日焦点报道 ）
            </span>
            <Link to={`/article/${featured.slug}`} className="group">
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight mb-1">
                {featured.title.split('：')[0]}
              </h2>
              <h3 className="text-2xl md:text-4xl font-bold font-heading text-foreground-300 leading-tight mb-8">
                {featured.title.split('：')[1] || featured.title}
              </h3>
            </Link>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-xl">
              「 {featured.excerpt} 」
            </p>

            <div className="flex items-center gap-3 mb-8">
              <span className="text-xs text-foreground-400">——</span>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{featured.author}</span>
              <span className="text-xs text-foreground-400">{featured.date}</span>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={handlePrev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 cursor-pointer hover:bg-background-100 transition-colors duration-200"
                aria-label="上一条"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 cursor-pointer hover:bg-foreground-800 transition-colors duration-200"
                aria-label="下一条"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-400 ml-2">
                {activeIndex + 1} / {latestArticles.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}